<app-main-menu title="Stimmen"></app-main-menu>

<div class="content mat-elevation-z8">
  <h1>Alle Stimmen</h1>

  <mat-form-field style="width:100%">
    <mat-label>Suchen</mat-label>
    <input matInput placeholder="Suche" [(ngModel)]="searchTerm" (input)="searchVoice($event)">
  </mat-form-field>

  <mat-list>
    <mat-list-item *ngFor="let voice of paginatedvoices" class="tune-list-item">
      <span matListItemTitle>{{ voice.designation }}
        <button mat-raised-button color="accent" class="mat-list-item-content-right" routerLink="/voices/{{ voice.id }}">
          Edit
        </button>
      </span>
      <span matListItemLine>{{ voice.instrumentgroup?.designation }}</span>
    </mat-list-item>
  </mat-list>

  <mat-paginator
    (page)="handlePageEvent($event)"
    [length]="voices.length"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 100]">
  </mat-paginator>


  <button mat-button routerLink="/voices/-1">
    <mat-icon>add_box</mat-icon>
    Stimme hinzufügen
  </button>
</div>
